import { render } from "./PigRunSummary.vue?vue&type=template&id=5874c387&scoped=true&ts=true"
import script from "./PigRunSummary.vue?vue&type=script&lang=ts"
export * from "./PigRunSummary.vue?vue&type=script&lang=ts"

import "./PigRunSummary.vue?vue&type=style&index=0&id=5874c387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5874c387"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
